<button mat-flat-button (click)="goBack()">
  <mat-icon [style.font-size.em]="iconSize" class="material-icons-round">keyboard_arrow_left</mat-icon>
  <span class="slash-class">/</span>
  <span [style.font-size.em]="breadCrumbSize"><strong>{{breadcrumbs | translate}}</strong></span>
</button>
